var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.formatPrice(_vm.cost, _vm.currency))+" "),(_vm.brandSetting('costs.show_vat', true))?_c('span',{staticClass:"text-xs"},[_vm._v("+ VAT")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }